import { useState } from 'react';
import { collections } from '@/mocks/collections';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function CollectionsPage() {
  const [hovered, setHovered] = useState<number | null>(null);

  return (
    <div>
      <Navbar />

      {/* Hero */}
      <section className="w-full relative h-[420px] md:h-[520px] overflow-hidden">
        <img
          src="https://public.readdy.ai/ai/img_res/15e4454da0762b12403dce6550253596.jpg"
          alt="Collections hero"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50" />
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6">
          <p className="text-white/60 text-xs tracking-[0.3em] uppercase mb-4">Curated Universes</p>
          <h1 className="text-5xl md:text-7xl font-bold text-white" style={{ fontFamily: "'Playfair Display', serif" }}>
            Our Collections
          </h1>
          <p className="text-white/70 mt-5 max-w-xl text-lg leading-relaxed">
            Discover cohesive worlds of design — each collection a story told through carefully chosen pieces.
          </p>
        </div>
      </section>

      {/* Collections Grid */}
      <section className="w-full bg-[#faf8f5] py-20 px-6 md:px-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {collections.map((col) => (
            <article
              key={col.id}
              className="group cursor-pointer"
              onMouseEnter={() => setHovered(col.id)}
              onMouseLeave={() => setHovered(null)}
            >
              <div className="relative w-full h-[280px] rounded-2xl overflow-hidden mb-5">
                <img
                  src={col.image}
                  alt={col.name}
                  title={`${col.name} furniture collection`}
                  className={`w-full h-full object-cover object-top transition-transform duration-700 ${
                    hovered === col.id ? 'scale-110' : 'scale-100'
                  }`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                <div className="absolute bottom-4 left-5 right-5">
                  <span className="text-white/70 text-xs uppercase tracking-widest">
                    {col.pieces} Pieces
                  </span>
                </div>
              </div>
              <div className="px-1">
                <h3
                  className="text-[#2c2420] text-xl font-semibold mb-1.5 group-hover:text-[#8B6348] transition-colors duration-200"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  {col.name}
                </h3>
                <p className="text-stone-400 text-sm leading-relaxed mb-3">{col.subtitle}</p>
                <span className="text-[#8B6348] text-xs font-medium uppercase tracking-wider flex items-center gap-1 group-hover:gap-2 transition-all duration-200">
                  Explore Collection <i className="ri-arrow-right-line" />
                </span>
              </div>
            </article>
          ))}
        </div>
      </section>

      {/* Bottom CTA */}
      <section className="w-full bg-[#2c2420] py-20 px-6 md:px-16 text-center">
        <p className="text-[#d4b896] text-xs uppercase tracking-[0.3em] mb-4 font-medium">Can't Find What You're Looking For?</p>
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-5" style={{ fontFamily: "'Playfair Display', serif" }}>
          Commission a Bespoke Piece
        </h2>
        <p className="text-stone-400 max-w-lg mx-auto text-base leading-relaxed mb-8">
          Work directly with our design team to create furniture that perfectly matches your vision and space.
        </p>
        <a
          href="/contact"
          className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-4 bg-[#8B6348] text-white text-sm font-medium tracking-wider rounded-full hover:bg-[#7a5540] transition-colors duration-200 cursor-pointer"
        >
          Start a Conversation <i className="ri-arrow-right-line" />
        </a>
      </section>

      <Footer />
    </div>
  );
}
